<label class="checkbox-container" [class.checked]="checked" [class.indeterminate]="indeterminate" [class.disabled]="disabled">
    <span class="content-wrapper">
        <ng-content></ng-content>
    </span>
    <input type="checkbox" [checked]="checked" [indeterminate]="indeterminate" (change)="onInputChange($event)" [disabled]="disabled">
    <span class="checkmark"></span>
</label>
